export default "<p>\n  examples works!\n</p>\n";